var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPixQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 95,
    viewBox: "0 0 111 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4141 55.6823V13.3218H54.7746V55.6823H12.4141ZM18.4656 49.6308H48.7231V19.3733H18.4656V49.6308ZM12.4141 110.146V67.7853H54.7746V110.146H12.4141ZM18.4656 104.094H48.7231V73.8368H18.4656V104.094ZM66.8776 55.6823V13.3218H109.238V55.6823H66.8776ZM72.9291 49.6308H103.187V19.3733H72.9291V49.6308ZM98.648 110.146V99.5557H109.238V110.146H98.648ZM66.8776 78.3754V67.7853H77.4677V78.3754H66.8776ZM77.4677 88.9656V78.3754H88.0578V88.9656H77.4677ZM66.8776 99.5557V88.9656H77.4677V99.5557H66.8776ZM77.4677 110.146V99.5557H88.0578V110.146H77.4677ZM88.0578 99.5557V88.9656H98.648V99.5557H88.0578ZM88.0578 78.3754V67.7853H98.648V78.3754H88.0578ZM98.648 88.9656V78.3754H109.238V88.9656H98.648Z",
    fill: "#433F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixQrCode);
export default __webpack_public_path__ + "static/media/pixQrCode.6f7b3b2360516dc414e275e615e7a31b.svg";
export { ForwardRef as ReactComponent };